import { defineComposable } from '@/core/utils/defineComposable'
import type VueIntercom from '@/services/vue-intercom/types'
import type { Ref } from 'vue'
import { ref } from 'vue'
import { inject } from 'vue'

type Intercom = {
  intercom: VueIntercom | null
  visible: Ref<boolean>
}

export const useIntercom = defineComposable(() => {
  const injected = inject('intercom') as Intercom | null

  const intercom = injected ? injected.intercom : null

  const visible = injected ? injected.visible : ref(false)

  return { intercom, visible } as Intercom
})

export const INTERCOM_EVENT = {
  UPGRADE: 'upgrade_request',
  SUPPORT: 'support_request',
} as const
